"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _colors = _interopRequireDefault(require("./colors"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = [{
  id: 'no-way',
  name: 'No way',
  color: _colors.default.LIGHT_BLUE
}, {
  id: 'maybe',
  name: 'Maybe',
  color: _colors.default.LIGHT_GREEN
}, {
  id: 'interview',
  name: 'Interview',
  color: _colors.default.GREEN
}, {
  id: 'hired',
  name: 'Hired',
  color: _colors.default.ORANGE
}];
exports.default = _default;